import React from 'react';

import classNames from 'classnames';
import CSSModules from 'react-css-modules';

import Text from '../../../TextComponents/Text';

import styles from './styles.module.scss';

type Props = {
  containerRef?: React.RefObject<HTMLButtonElement>;
  contentRef?: React.RefObject<HTMLSpanElement>;
  onClick: () => void;
  text?: string;
  url?: string;
  isButtonLightTheme?: boolean;
  isCoursePreview: boolean;
  isLoading: boolean;
  isInAdminPanel: boolean;
};

const CompletionButton = ({
  containerRef,
  contentRef,
  onClick,
  url,
  text,
  isButtonLightTheme,
  isCoursePreview,
  isLoading,
  isInAdminPanel,
}: Props) => (
  <button
    ref={containerRef}
    styleName={classNames('button', {
      light: isButtonLightTheme,
      'admin-preview': isInAdminPanel,
    })}
    disabled={(isCoursePreview && !url) || isLoading}
    onClick={onClick}
    data-automation='progress-button'
  >
    {isLoading ? (
      <div styleName='circles'>
        <div />
        <div />
        <div />
      </div>
    ) : (
      <Text
        size={isInAdminPanel ? 'm' : 'l'}
        colour={isButtonLightTheme ? 'textPrimary' : 'white'}
        lineHeight='tight'
        weight='medium'
        maxLines={2}
      >
        <span ref={contentRef}>{text}</span>
      </Text>
    )}
  </button>
);

export default CSSModules(CompletionButton, styles, {allowMultiple: true});
